import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { AuthService } from '../Services/auth';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    try {
      if (this.authService && this.authService.isLoggedIn && this.authService.isLoggedIn()) {
        return true;
      }
    } catch (e) {
      console.warn('AuthGuard check failed', e);
    }
    // Not logged in — redirect to root (login) and preserve intended URL
    return this.router.createUrlTree([''], { queryParams: { returnUrl: state.url } });
  }
}
